import AdminUploadEventStyle from "../ClubOwnerStyles/ClubOwnerUploadEventStyle.module.css";
import React, { useState, useEffect } from "react";
import axios from "axios";
import Select from "react-select";
import MapsManager from "../../components/TablesComp/MapsManager";
import TrashcanIcon from "../../icons/Trash can.svg";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faImage, faTimes } from "@fortawesome/free-solid-svg-icons";
import Modal from "react-modal";
import ClipLoader from "react-spinners/ClipLoader";

const ClubOwnerUploadEvent = () => {
  const adminId = localStorage.getItem("adminId");
  const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
  const [clubs, setClubs] = useState({});
  const [djNames, setDjNames] = useState([]);
  const [djOptions, setdjOptions] = useState([]);
  const [music_types, setMusicTypes] = useState([]);
  const [cities, setCities] = useState([]);
  const [selectedImage, setSelectedImage] = useState(null);
  const username = localStorage.getItem("name");
  const [isLoadingSumbitEvent, setIsLoadingEvent] = useState(false);
  const [responseEvent, setResponseEvent] = useState(null);
  const [errorEvent, setErrorEvent] = useState("");
  const [AlertEvent, setAlertEvent] = useState(false);
  const [currentTicketIndex, setCurrentTicketIndex] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isLoadingSubmitEvent, setIsLoadingSubmitEvent] = useState(false);
  const [selectedFolder, setSelectedFolder] = useState(null);
  const [formData, setFormData] = useState({
    club: { id: "", name: "" },
    eventDate: "",
    eventTime: "",
    eventName: "",
    imageUpload: null,
    numberOfParticipants: 0,
    timeOfExpiration: 0,
    prName: "",
    qrTech: "",
    ticketLink: "",
    scanKey: "",
    music_type: [],
    musicType: [],
    DJ_name: [],
    city: [],
    sponsored: false,
    DressCode: "", // New field for Dress Code
    Age: "" // New field for Age
  });
  const [formErrors, setFormErrors] = useState({});
  const validateForm = () => {
    const errors = {};

    if (!formData.club?.id) {
      errors.club = "Club is required.";
    }
    if (!formData.eventDate) {
      errors.eventDate = "Event date is required.";
    }
    if (!formData.eventTime) {
      errors.eventTime = "Event time is required.";
    }
    if (!formData.eventName) {
      errors.eventName = "Event name is required.";
    }
    if (!formData.DressCode) {
      errors.DressCode = "Dress code is required.";
    }
    if (!formData.Age || formData.Age <= 0) {
      errors.Age = "Age must be greater than 0.";
    }
    if (!formData.city || formData.city.length === 0) {
      errors.city = "At least one city is required.";
    }
    if (!formData.image_base64) {
      errors.image_base64 = "Banner image is required.";
    }
    if (!tickets || tickets.length === 0) {
      errors.tickets = "At least one ticket type must be added.";
    } else {
      // Validate each ticket and filter out valid tickets
      const ticketErrors = tickets
        .map((ticket) => {
          const error = {};
          if (!ticket.price && ticket.price !== 0) {
            error.price = "Price is required.";
          }
          if (!ticket.numberOfTicketsLeft && ticket.numberOfTicketsLeft !== 0) {
            error.numberOfTicketsLeft = "Quantity is required.";
          }
          if (!ticket.timeofexpir) {
            error.timeofexpir = "End sells time is required.";
          }
          if (!ticket.description) {
            error.description = "Description is required.";
          }
          if (!ticket.ticketImage) {
            error.ticketImage = "Ticket image is required.";
          }
          return Object.keys(error).length > 0 ? error : null;
        })
        .filter((error) => error !== null); // Filter out null errors

      if (ticketErrors.length > 0) {
        errors.tickets = ticketErrors;
      }
    }

    if (!formData.terms) {
      errors.terms = "You must accept the Terms and Conditions.";
    }

    setFormErrors(errors);
    console.log("errors: ", errors);

    // If errors object is empty, return true (no errors)
    return Object.keys(errors).length === 0;
  };

  const [tickets, setTickets] = useState([]);

  const TICKET_IMAGES = {
    "Pago En Puerta": ["https://everywherestorage.blob.core.windows.net/scannerimages/PagoEnPuerta.jpg"],
    "Lista": ["https://everywherestorage.blob.core.windows.net/scannerimages/EntradaEnLista.jpg"],
    "Barra Libre": ["https://everywherestorage.blob.core.windows.net/scannerimages/BarraLibre.jpg"],
    "1-copa": [
      "https://everywherestorage.blob.core.windows.net/scannerimages/1copa-100.jpg",
      "https://everywherestorage.blob.core.windows.net/scannerimages/1copa-95.jpg",
      "https://everywherestorage.blob.core.windows.net/scannerimages/1copa-90.jpg",
      "https://everywherestorage.blob.core.windows.net/scannerimages/1copa-85.jpg",
      "https://everywherestorage.blob.core.windows.net/scannerimages/1copa-80.jpg",
      "https://everywherestorage.blob.core.windows.net/scannerimages/1copa-75.jpg",
      "https://everywherestorage.blob.core.windows.net/scannerimages/1copa-70.jpg",
      "https://everywherestorage.blob.core.windows.net/scannerimages/1copa-65.jpg",
      "https://everywherestorage.blob.core.windows.net/scannerimages/1copa-60.jpg",
      "https://everywherestorage.blob.core.windows.net/scannerimages/1copa-55.jpg",
      "https://everywherestorage.blob.core.windows.net/scannerimages/1copa-50.jpg",
      "https://everywherestorage.blob.core.windows.net/scannerimages/1copa-45.jpg",
      "https://everywherestorage.blob.core.windows.net/scannerimages/1copa-40.jpg",
      "https://everywherestorage.blob.core.windows.net/scannerimages/1copa-35.jpg",
      "https://everywherestorage.blob.core.windows.net/scannerimages/1copa-30.jpg",
      "https://everywherestorage.blob.core.windows.net/scannerimages/1copa-29.jpg",
      "https://everywherestorage.blob.core.windows.net/scannerimages/1copa-28.jpg",
      "https://everywherestorage.blob.core.windows.net/scannerimages/1copa-27.jpg",
      "https://everywherestorage.blob.core.windows.net/scannerimages/1copa-26.jpg",
      "https://everywherestorage.blob.core.windows.net/scannerimages/1copa-25.jpg",
      "https://everywherestorage.blob.core.windows.net/scannerimages/1copa-24.jpg",
      "https://everywherestorage.blob.core.windows.net/scannerimages/1copa-23.jpg",
      "https://everywherestorage.blob.core.windows.net/scannerimages/1copa-22.jpg",
      "https://everywherestorage.blob.core.windows.net/scannerimages/1copa-21.jpg",
      "https://everywherestorage.blob.core.windows.net/scannerimages/1copa-20.jpg",
      "https://everywherestorage.blob.core.windows.net/scannerimages/1copa-19.jpg",
      "https://everywherestorage.blob.core.windows.net/scannerimages/1copa-18.jpg",
      "https://everywherestorage.blob.core.windows.net/scannerimages/1copa-17.jpg",
      "https://everywherestorage.blob.core.windows.net/scannerimages/1copa-16.jpg",
      "https://everywherestorage.blob.core.windows.net/scannerimages/1copa-15.jpg",
      "https://everywherestorage.blob.core.windows.net/scannerimages/1copa-14.jpg",
      "https://everywherestorage.blob.core.windows.net/scannerimages/1copa-13.jpg",
      "https://everywherestorage.blob.core.windows.net/scannerimages/1copa-12.jpg",
      "https://everywherestorage.blob.core.windows.net/scannerimages/1copa-11.jpg",
      "https://everywherestorage.blob.core.windows.net/scannerimages/1copa-10.jpg",
    ],
    "2-copas": [
      "https://everywherestorage.blob.core.windows.net/scannerimages/2copas-100.jpg",
      "https://everywherestorage.blob.core.windows.net/scannerimages/2copas-95.jpg",
      "https://everywherestorage.blob.core.windows.net/scannerimages/2copas-90.jpg",
      "https://everywherestorage.blob.core.windows.net/scannerimages/2copas-85.jpg",
      "https://everywherestorage.blob.core.windows.net/scannerimages/2copas-80.jpg",
      "https://everywherestorage.blob.core.windows.net/scannerimages/2copas-75.jpg",
      "https://everywherestorage.blob.core.windows.net/scannerimages/2copas-70.jpg",
      "https://everywherestorage.blob.core.windows.net/scannerimages/2copas-65.jpg",
      "https://everywherestorage.blob.core.windows.net/scannerimages/2copas-60.jpg",
      "https://everywherestorage.blob.core.windows.net/scannerimages/2copas-55.jpg",
      "https://everywherestorage.blob.core.windows.net/scannerimages/2copas-50.jpg",
      "https://everywherestorage.blob.core.windows.net/scannerimages/2copas-45.jpg",
      "https://everywherestorage.blob.core.windows.net/scannerimages/2copas-40.jpg",
      "https://everywherestorage.blob.core.windows.net/scannerimages/2copas-35.jpg",
      "https://everywherestorage.blob.core.windows.net/scannerimages/2copas-30.jpg",
      "https://everywherestorage.blob.core.windows.net/scannerimages/2copas-25.jpg",
      "https://everywherestorage.blob.core.windows.net/scannerimages/2copas-20.jpg",
      "https://everywherestorage.blob.core.windows.net/scannerimages/2copas-15.jpg",
      "https://everywherestorage.blob.core.windows.net/scannerimages/2copas-10.jpg",
      "https://everywherestorage.blob.core.windows.net/scannerimages/2copas-5.jpg",
    ],
    "3-copas": [
      "https://everywherestorage.blob.core.windows.net/scannerimages/3copas-100.jpg",
      "https://everywherestorage.blob.core.windows.net/scannerimages/3copas-90.jpg",
      "https://everywherestorage.blob.core.windows.net/scannerimages/3copas-85.jpg",
      "https://everywherestorage.blob.core.windows.net/scannerimages/3copas-80.jpg",
      "https://everywherestorage.blob.core.windows.net/scannerimages/3copas-75.jpg",
      "https://everywherestorage.blob.core.windows.net/scannerimages/3copas-70.jpg",
      "https://everywherestorage.blob.core.windows.net/scannerimages/3copas-65.jpg",
      "https://everywherestorage.blob.core.windows.net/scannerimages/3copas-60.jpg",
      "https://everywherestorage.blob.core.windows.net/scannerimages/3copas-55.jpg",
      "https://everywherestorage.blob.core.windows.net/scannerimages/3copas-50.jpg",
      "https://everywherestorage.blob.core.windows.net/scannerimages/3copas-45.jpg",
      "https://everywherestorage.blob.core.windows.net/scannerimages/3copas-40.jpg",
      "https://everywherestorage.blob.core.windows.net/scannerimages/3copas-35.jpg",
      "https://everywherestorage.blob.core.windows.net/scannerimages/3copas-30.jpg",
      "https://everywherestorage.blob.core.windows.net/scannerimages/3copas-25.jpg",
      "https://everywherestorage.blob.core.windows.net/scannerimages/3copas-20.jpg",
      "https://everywherestorage.blob.core.windows.net/scannerimages/3copas-15.jpg",
      "https://everywherestorage.blob.core.windows.net/scannerimages/3copas-10.jpg",
    ],
    "Acceso Sin Consumo": [
      "https://everywherestorage.blob.core.windows.net/scannerimages/SinConsumo-90.jpg",
      "https://everywherestorage.blob.core.windows.net/scannerimages/SinConsumo-85.jpg",
      "https://everywherestorage.blob.core.windows.net/scannerimages/SinConsumo-80.jpg",
      "https://everywherestorage.blob.core.windows.net/scannerimages/SinConsumo-75.jpg",
      "https://everywherestorage.blob.core.windows.net/scannerimages/SinConsumo-70.jpg",
      "https://everywherestorage.blob.core.windows.net/scannerimages/SinConsumo-65.jpg",
      "https://everywherestorage.blob.core.windows.net/scannerimages/SinConsumo-60.jpg",
      "https://everywherestorage.blob.core.windows.net/scannerimages/SinConsumo-55.jpg",
      "https://everywherestorage.blob.core.windows.net/scannerimages/SinConsumo-50.jpg",
      "https://everywherestorage.blob.core.windows.net/scannerimages/SinConsumo-45.jpg",
      "https://everywherestorage.blob.core.windows.net/scannerimages/SinConsumo-40.jpg",
      "https://everywherestorage.blob.core.windows.net/scannerimages/SinConsumo-35.jpg",
      "https://everywherestorage.blob.core.windows.net/scannerimages/SinConsumo-30.jpg",
      "https://everywherestorage.blob.core.windows.net/scannerimages/SinConsumo-25.jpg",
      "https://everywherestorage.blob.core.windows.net/scannerimages/SinConsumo-20.jpg",
      "https://everywherestorage.blob.core.windows.net/scannerimages/SinConsumo-15.jpg",
      "https://everywherestorage.blob.core.windows.net/scannerimages/SinConsumo-10.jpg",
      "https://everywherestorage.blob.core.windows.net/scannerimages/SinConsumo-5.jpg",
    ]
  };

  const ALL_TICKET_TYPES = [
    "guest list",
    "GIRLS ONLY: guest list",
    "guest list 2nd",
    "guest list 3rd",
    "guest list 4th",
    "Early Birds Paid Entrance",
    "Paid Entrance 1st offer",
    "Paid Entrance 2nd offer",
    "Paid Entrance 3rd offer",
    "Paid Entrance 4th offer",
    "Paid Entrance 5th offer",
    "Paid Entrance 6th offer",
    "discount entrance: pay online",
    "discount entrance: pay at the door",
    "BOYS: 1ST Paid RELEASE OFFER",
    "GIRLS: 1ST Paid RELEASE OFFER",
    "BOYS: 2ND Paid RELEASE OFFER",
    "GIRLS: 2ND Paid RELEASE OFFER",
    "BOYS: 3RD Paid RELEASE OFFER",
    "GIRLS: 3RD Paid RELEASE OFFER"
  ];


  const DEFAULT_TICKET = {
    type: ALL_TICKET_TYPES.GuestList,
    price: "-",
    numberOfTicketsLeft: "0 Tickets",
    start: "",
    end: "",
    description: "Write your description here.",
    ticketImage: null
  };

  // State to hold the selected ticket type for adding a new one
  const [selectedTicketType, setSelectedTicketType] = useState(
    ALL_TICKET_TYPES[0]
  );

  const findNextAvailableTicketType = (currentType) => {
    const currentIndex = ALL_TICKET_TYPES.indexOf(currentType);
    for (let i = currentIndex + 1; i < ALL_TICKET_TYPES.length; i++) {
      if (
        !tickets.some((ticket) => ticket.ticketType === ALL_TICKET_TYPES[i])
      ) {
        return ALL_TICKET_TYPES[i];
      }
    }
    return null; // Return null if all types are added or no next type found
  };
  const addSelectedTicketType = (type) => {
    let typeToAdd = type;
    const ticketAlreadyExists = tickets.some(
      (ticket) => ticket.type === typeToAdd
    );

    if (ticketAlreadyExists) {
      const nextAvailableType = findNextAvailableTicketType(typeToAdd);
      if (nextAvailableType) {
        typeToAdd = nextAvailableType;
      } else {
        alert(
          "This ticket type has already been added, and no other types are available to add."
        );
        return; // Exit the function if no type available to add
      }
    }

    const newTicket = {
      ticketType: typeToAdd,
      price: typeToAdd === "guest list" ? "0€" : "20€", // Assuming a default price of 20€ for non-guest list
      numberOfTicketsLeft: "",
      ticketAvailability:
        typeToAdd === "guest list" ? "0 Tickets" : "Available Tickets", // Proper property name and better message
      timeofexpir: "", // Changed to camelCase for consistency
      description: "Write your description here.",
      ticketImage: null, // Initialize with null
      deletable: true
    };
    setTickets([...tickets, newTicket]);
  };
  const handleTicketChange = (index, name, value) => {
    const updatedTickets = [...tickets];

    if (name === "price") {
      value = parseFloat(value) || 0.0; // Parse the value as a float
    } else if (name === "numberOfTicketsLeft") {
      value = parseInt(value, 10) || 0; // Parse the value as an integer
    } else if (name === "timeofexpir") {
      const [hours, minutes] = value.split(":").map(Number);
      value = hours + minutes / 60;
    }
    updatedTickets[index][name] = value;
    setTickets(updatedTickets);
  };
  const deleteTicketType = (index) => {
    setTickets((prevTickets) => prevTickets.filter((_, i) => i !== index));
  };
  const toggleTicketTypes = () => {
    setShowTicketTypes(!showTicketTypes);
  };
  const handleAddTicketType = (type) => {
    // Check if the type has already been added
    if (tickets.some((ticket) => ticket.ticketType === type)) {
      alert("This ticket type has already been added.");
      return;
    }

    const isGuestList = type.toLowerCase().includes("guest list");
    const newTicket = {
      ticketType: type,
      price: isGuestList ? 0 : 0.0, // Assign "0€" to guest list tickets
      numberOfTicketsLeft: "", // Leave blank for user input
      timeofexpir: "",
      end: "",
      description: "",
      deletable: true // Allow deletion
    };

    // Update the state with the new ticket
    setTickets([...tickets, newTicket]);
  };

  // Handler for when any of the dropdowns or inputs change
  const handleInputChange = (index, field, value) => {
    const newTickets = [...tickets];
    newTickets[index][field] = value;
    setTickets(newTickets);
  };

  const [imageBase64, setImageBase64] = useState("");

  useEffect(() => {
    // Assuming you have a function to load your backend URL
    fetchClubs();
    fetchDjNames();
    fetchMusicTypes();
    fetchCities();
  }, []);

  const fetchClubs = async () => {
    try {
      let token = localStorage.getItem("token");
      const response = await axios.get(
        `${BACKEND_URL}/admin/getAllClubs/${adminId}`,
        {
          headers: {
            authorization: `Bearer ${token}`
          }
        }
      );
      console.log(response);
      if (response.status === 200) {
        setClubs(response.data);
        if (Object.keys(response.data).length > 0 && !formData.club) {
          const firstClubValue = Object.values(response.data)[0]; // Get the first club's value
          setFormData((prevState) => ({
            ...prevState,
            club: firstClubValue // Set the first club value as the default
          }));
        }
        console.log("formData: ", formData);
      }
    } catch (error) {
      console.error("Failed to fetch clubs:", error);
    }
  };

  const fetchDjNames = async () => {
    try {
      let token = localStorage.getItem("token");
      const response = await axios.get(`${BACKEND_URL}/admin/getDjNames/`,
        {
          headers: {
            authorization: `Bearer ${token}`
          }
        }
      );
      if (response.status === 200) {
        console.log("response.data: ", response.data);
        setDjNames(response.data);
        setdjOptions(
          response.data.map((djName) => ({
            value: djName,
            label: djName
          }))
        );
      }
    } catch (error) {
      console.error("Failed to fetch DJ names:", error);
    }
  };

  const fetchMusicTypes = async () => {
    try {
      let token = localStorage.getItem("token");
      const response = await axios.get(`${BACKEND_URL}/admin/music-types/`,
        {
          headers: {
            authorization: `Bearer ${token}`
          }
        }
      );
      if (response.status === 200) {
        console.log("Music: ", response.data.music_types);
        setMusicTypes(
          response.data.music_types.map((music_type) => ({
            value: music_type,
            label: music_type
          }))
        );
      }
    } catch (error) {
      console.error("Failed to fetch DJ names:", error);
    }
  };
  const fetchCities = async () => {
    try {
      let token = localStorage.getItem("token");
      const response = await axios.get(`${BACKEND_URL}/admin/cities/`,
        {
          headers: {
            authorization: `Bearer ${token}`
          }
        }

      );
      if (response.status === 200) {
        setCities(
          response.data.cities.map((city) => ({
            value: city,
            label: city
          }))
        );
      }
    } catch (error) {
      console.error("Failed to fetch DJ names:", error);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevState) => ({
      ...prevState,
      [name]: value
    }));
  };

  const handleClubChange = (e) => {
    const selectedClubId = e.target.value;
    const selectedClubName = e.target.options[e.target.selectedIndex].text;

    setFormData((prevState) => ({
      ...prevState,
      club: { id: selectedClubId, name: selectedClubName }
    }));
  };
  const handleMultiSelectChangeDj = (selectedOptions) => {
    setFormData((prevState) => ({
      ...prevState,
      DJ_name: selectedOptions.map((option) => option.value) || []
    }));
  };
  const handleMultiSelectChangeMusic = (selectedOptions) => {
    setFormData((prevState) => ({
      ...prevState,
      music_type: selectedOptions.map((option) => option.value) || []
    }));
  };
  const handleMultiSelectChangeCities = (selectedOptions) => {
    setFormData((prevState) => ({
      ...prevState,
      city: selectedOptions.map((option) => option.value) || []
    }));
  };

  // Handle changes for the multi-select (react-select) input
  const handleMultiSelectChange = (selectedOptions) => {
    setFormData((prevState) => ({
      ...prevState,
      djNames: selectedOptions || []
    }));
  };
  useEffect(() => {
    console.log("formData: ", formData);
  }, [formData]);

  const handleImageUpload = (e) => {
    const file = e.target.files[0];
    const reader = new FileReader();

    reader.onload = (event) => {
      const imgElement = document.createElement("img");
      imgElement.src = event.target.result;

      imgElement.onload = () => {
        const canvas = document.createElement("canvas");
        const max_width = 800; // Set the maximum width or adjust according to your needs
        const max_height = 600; // Set the maximum height or adjust according to your needs

        let width = imgElement.width;
        let height = imgElement.height;

        // Calculate the new dimensions based on max width and height
        if (width > height) {
          if (width > max_width) {
            height *= max_width / width;
            width = max_width;
          }
        } else {
          if (height > max_height) {
            width *= max_height / height;
            height = max_height;
          }
        }

        canvas.width = width;
        canvas.height = height;

        // Draw the image with the new width and height
        const ctx = canvas.getContext("2d");
        ctx.drawImage(imgElement, 0, 0, width, height);

        // Convert the canvas to a base64 string with quality parameter
        const base64String = canvas.toDataURL("image/jpeg", 0.7); // Adjust the quality from 0 to 1

        console.log("Compressed Base64: ", base64String);

        // Update the state with the base64 string and the file
        setImageBase64(base64String);
        setFormData((prevState) => ({
          ...prevState,
          image_base64: base64String
        }));
      };
    };

    reader.readAsDataURL(file);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoadingSubmitEvent(true);
    if (!validateForm()) {
      // If validation fails, do not proceed with submission
      setIsLoadingSubmitEvent(false);
      alert("Missing information in the input fields");
      return;
    }
    const localDateTime = new Date(
      `${formData.eventDate}T${formData.eventTime}`
    );

    // Convert local Date to UTC
    const utcDateTime = new Date(localDateTime.toUTCString());
    const eventDetails = {
      ...formData,
      dateAndHour: utcDateTime.toISOString()
    };
    try {
      let token = localStorage.getItem("token");
      // Submit event details first
      const eventResponse = await axios.post(
        `${BACKEND_URL}/events/uploadevent`,
        eventDetails,
        {
          headers: {
            authorization: `Bearer ${token}`
          }
        }
      );

      console.log("eventResponse: ", eventResponse);

      const { event } = eventResponse.data;
      const eventId = event._id; // Get the event ID from the response

      // Submit tickets with the event ID
      const ticketPromises = tickets.map((ticket) => {
        console.log("ticket: ", ticket);
        const ticketData = {
          ...eventDetails,
          ...ticket,
          eventName: event.eventName,
          dateAndHour: event.dateAndHour
        };
        let token = localStorage.getItem("token");
        return axios.post(`${BACKEND_URL}/events/uploadevent`, ticketData, {
          headers: {
            authorization: `Bearer ${token}`
          }
        });
      });

      await Promise.all(ticketPromises);
      setIsLoadingSubmitEvent(false);
      alert("Event and tickets submitted successfully");
    } catch (error) {
      setAlertEvent(true);

      if (error.response) {
        const status = error.response.status;
        setIsLoadingSubmitEvent(false);
        if (status === 400) {
          setErrorEvent("Bad Request: Please check your input data.");
        } else if (status === 401) {
          setErrorEvent("Unauthorized: Please check your credentials.");
        } else {
          setErrorEvent(
            `Error ${status}: ${error.response.data.message || "An error occurred."}`
          );
        }
      } else if (error.request) {
        setErrorEvent("No response from server. Please try again later.");
      } else {
        setErrorEvent(`Error: ${error.message}`);
      }

      console.error("Error submitting event and tickets:", error);
    }
  };

  const handleChangeBox = (e) => {
    const { name, checked } = e.target;
    setFormData((prevState) => ({
      ...prevState,
      [name]: checked
    }));
  };

  // Function to handle Enter key in textarea to prevent form submission
  const handleKeyDown = (e, index) => {
    if (e.key === "Enter" && !e.shiftKey) {
      e.preventDefault();
      // Add any additional behavior for the Enter key here, if needed
    }
  };
  const handleSelectTicketImage = (index) => {
    setCurrentTicketIndex(index);
    setIsModalOpen(true);
  };
  const handleImageSelection = (imageUrl) => {
    const updatedTickets = [...tickets];
    updatedTickets[currentTicketIndex].ticketImage = imageUrl;
    setTickets(updatedTickets);
    setIsModalOpen(false);
  };

  const [showTicketTypes, setShowTicketTypes] = useState(false);

  // Render form with onChange for inputs and onSubmit for the form
  return (
    <div className={AdminUploadEventStyle.dashboard}>

      <Modal
        isOpen={isModalOpen}
        onRequestClose={() => setIsModalOpen(false)}
        contentLabel="Select Ticket Image"
        style={{
          content: {
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            backgroundColor: "#F0F0F0",
            borderRadius: "5px",
            width: "60%",
            height: "auto",
          },
          overlay: { backgroundColor: "rgba(0, 0, 0, 0.5)" },
        }}
      >
        <h2>Select Ticket Image</h2>
        {!selectedFolder ? (
          <div className={AdminUploadEventStyle.folderSelection}>
            {Object.keys(TICKET_IMAGES).map((folderName) => (
              <button
                key={folderName}
                onClick={() => setSelectedFolder(folderName)}
                className={AdminUploadEventStyle.folderButton}
              >
                {folderName}
              </button>
            ))}
          </div>
        ) : (
          <div className={AdminUploadEventStyle.imageSelection}>
            <button
              className={AdminUploadEventStyle.backButton}
              onClick={() => setSelectedFolder(null)}
            >
              Atras
            </button>
            {TICKET_IMAGES[selectedFolder].map((imageUrl, index) => (
              <img
                key={index}
                src={imageUrl}
                alt={`Ticket option ${index}`}
                onClick={() => handleImageSelection(imageUrl)}
                className={`${AdminUploadEventStyle.selectableImage} ${tickets[currentTicketIndex]?.ticketImage === imageUrl
                  ? AdminUploadEventStyle.selectedImage
                  : ""
                  }`}
              />
            ))}

          </div>
        )}
        <button
          className={AdminUploadEventStyle.closeButton}
          onClick={() => setIsModalOpen(false)}
        >
          <FontAwesomeIcon icon={faTimes} />
        </button>
      </Modal>
      <div className={AdminUploadEventStyle.header}>
        <h1>Hello {username}!</h1>
        <p>Welcome back!</p>
      </div>
      <h1 className={AdminUploadEventStyle.Title}>Upload a New Event</h1>
      {AlertEvent && errorEvent && (
        <div className={AdminUploadEventStyle.errorMessage}>
          <p>{errorEvent}</p>
        </div>
      )}
      <form
        onSubmit={handleSubmit}
        className={AdminUploadEventStyle.formContainer}
      >
        <div className={AdminUploadEventStyle.formItem}>
          <label className={AdminUploadEventStyle.formLabel}>
            Club
            <select
              name="club_id"
              value={formData.club.id}
              onChange={handleClubChange}
              className={AdminUploadEventStyle.formInput}
            >
              <option value="">Select a club</option>
              {Object.entries(clubs).map(([clubname, clubId]) => (
                <option key={clubId} value={clubId}>
                  {clubname}
                </option>
              ))}
            </select>
            {formErrors.club && (
              <div className={AdminUploadEventStyle.errorMessage}>
                {formErrors.club}
              </div>
            )}
          </label>
        </div>
        <div className={AdminUploadEventStyle.formItem}>
          <label className={AdminUploadEventStyle.formLabel}>
            Event Date
            <input
              type="date"
              name="eventDate"
              value={formData.eventDate}
              onChange={handleChange}
              className={AdminUploadEventStyle.formInput}
              s
            />
          </label>
          {formErrors.eventDate && (
            <div className={AdminUploadEventStyle.errorMessage}>
              {formErrors.eventDate}
            </div>
          )}
        </div>
        <div className={AdminUploadEventStyle.formItem}>
          <label className={AdminUploadEventStyle.formLabel}>
            Event Time
            <input
              type="time"
              name="eventTime"
              value={formData.eventTime}
              onChange={handleChange}
              className={AdminUploadEventStyle.formInput}
            />
          </label>
          {formErrors.eventTime && (
            <div className={AdminUploadEventStyle.errorMessage}>
              {formErrors.eventTime}
            </div>
          )}
        </div>
        <div className={AdminUploadEventStyle.formItem}>
          <label className={AdminUploadEventStyle.formLabel}>
            Event Name
            <input
              type="text"
              name="eventName"
              value={formData.eventName}
              onChange={handleChange}
              className={AdminUploadEventStyle.formInput}
            />
          </label>
          {formErrors.eventName && (
            <div className={AdminUploadEventStyle.errorMessage}>
              {formErrors.eventName}
            </div>
          )}
        </div>
        <div className={AdminUploadEventStyle.formItem}>
          <label className={AdminUploadEventStyle.formLabel}>
            Dress Code
            <input
              type="text"
              name="DressCode"
              value={formData.DressCode}
              onChange={handleChange}
              className={AdminUploadEventStyle.formInput}
            />
          </label>
          {formErrors.DressCode && (
            <div className={AdminUploadEventStyle.errorMessage}>
              {formErrors.DressCode}
            </div>
          )}
        </div>

        <div className={AdminUploadEventStyle.formItem}>
          <label className={AdminUploadEventStyle.formLabel}>
            Age
            <input
              type="number"
              name="Age"
              value={formData.Age}
              onChange={handleChange}
              className={AdminUploadEventStyle.formInput}
            />
          </label>
          {formErrors.Age && (
            <div className={AdminUploadEventStyle.errorMessage}>
              {formErrors.Age}
            </div>
          )}
        </div>
        <div className={AdminUploadEventStyle.formItem}>
          <label className={AdminUploadEventStyle.formLabel}>
            QR Tech
            <select
              name="qrTech"
              value={formData.qrTech}
              onChange={handleChange}
              className={AdminUploadEventStyle.formInput}
            >
              <option value="PATT_TECH">PATT_TECH</option>
              {/* Add other QR Tech options here */}
            </select>
          </label>
        </div>
        <div className={AdminUploadEventStyle.formItem}>
          <label className={AdminUploadEventStyle.formLabel}>
            Music Type
            <Select
              name="music_type"
              onChange={handleMultiSelectChangeMusic} // Use the custom handler for react-select
              options={music_types}
              className={AdminUploadEventStyle.formInput}
              isMulti={true} // Enable multi-selection
              isSearchable={true} // Enable searching
            />
          </label>
        </div>
        <div className={AdminUploadEventStyle.formItem}>
          <label className={AdminUploadEventStyle.formLabel}>
            DJ Name
            <Select
              name="DJ_name"
              onChange={handleMultiSelectChangeDj} // Use the custom handler for react-select
              options={djOptions}
              className={AdminUploadEventStyle.formInput}
              isMulti={true} // Enable multi-selection
              isSearchable={true} // Enable searching
            />
          </label>
        </div>
        <div className={AdminUploadEventStyle.formItem}>
          <label className={AdminUploadEventStyle.formLabel}>
            City
            <Select
              name="city"
              onChange={handleMultiSelectChangeCities} // Use the custom handler for react-select
              options={cities}
              className={AdminUploadEventStyle.formInput}
              isMulti={true} // Enable multi-selection
              isSearchable={true} // Enable searching
            />
          </label>
          {formErrors.city && (
            <div className={AdminUploadEventStyle.errorMessage}>
              {formErrors.city}
            </div>
          )}
        </div>

        <div
          style={{
            marginBottom: "20px",
            gridColumn: "1 / -1",
            fontSize: "20px"
          }}
        >
          <label className={AdminUploadEventStyle.formLabel}>
            Add A Banner Picture
          </label>
          {selectedImage && (
            <div>
              <img
                alt="not found"
                width={"250px"}
                src={URL.createObjectURL(selectedImage)}
              />
              <br />
              <button
                onClick={() => setSelectedImage(null)}
                class={AdminUploadEventStyle.addPromoterButton}
              >
                Remove
              </button>
            </div>
          )}
          <input
            type="file"
            name="myImage"
            class={AdminUploadEventStyle.addPromoterButton}
            onChange={(event) => {
              setSelectedImage(event.target.files[0]);
              handleImageUpload(event);
            }}
          />
          {formErrors.image_base64 && (
            <div className={AdminUploadEventStyle.errorMessage}>
              {formErrors.image_base64}
            </div>
          )}
        </div>
        <h1
          style={{
            gridColumn: "1 / -1",
            fontSize: "20px"
          }}
        >
          Add your Ticket Information
        </h1>

        <div
          style={{ gridColumn: "1 / -1" }}
          class={AdminUploadEventStyle.sectionStyle}
        >
          <table>
            <thead>
              <tr>
                <th>Type</th>
                <th>Price</th>
                <th>Quantity</th>
                <th>End Sells</th>
                <th>Description</th>
                <th>Image</th>
              </tr>
            </thead>
            <tbody>
              {tickets.map((ticket, index) => (
                <>
                  <tr key={index}>
                    <td className={AdminUploadEventStyle.ticketname}>
                      {ticket.ticketType}
                    </td>
                    {/* Price Input Field */}
                    <td className={AdminUploadEventStyle.inputWithEuro}>
                      <div className={AdminUploadEventStyle.inputGroup}>
                        <input
                          type="text"
                          value={ticket.price}
                          onChange={(e) =>
                            handleTicketChange(index, "price", e.target.value)
                          }
                          onKeyDown={(e) => handleKeyDown(e, index)}
                          className={`${AdminUploadEventStyle.input} ${formErrors.tickets &&
                            formErrors.tickets[index] &&
                            formErrors.tickets[index].price
                            ? AdminUploadEventStyle.errorInput
                            : ""
                            }`}
                          style={{ textAlign: "right" }} // Keeping for alignment
                          disabled={ticket.ticketType
                            .toLowerCase()
                            .includes("guest list")} // Disable input if ticket type includes any case variation of "Guest List"
                        />
                        <span className={AdminUploadEventStyle.currency}>
                          €
                        </span>
                      </div>
                      {formErrors.tickets &&
                        formErrors.tickets[index] &&
                        formErrors.tickets[index].price && (
                          <div className={AdminUploadEventStyle.errorMessage}>
                            {formErrors.tickets[index].price}
                          </div>
                        )}
                    </td>
                    {/* Quantity Input Field */}
                    <td className={AdminUploadEventStyle.inputWithTickets}>
                      <div className={AdminUploadEventStyle.inputGroup}>
                        <input
                          type="text"
                          value={ticket.numberOfTicketsLeft}
                          onChange={(e) =>
                            handleTicketChange(
                              index,
                              "numberOfTicketsLeft",
                              e.target.value
                            )
                          }
                          onKeyDown={(e) => handleKeyDown(e, index)}
                          className={`${AdminUploadEventStyle.input} ${formErrors.tickets &&
                            formErrors.tickets[index] &&
                            formErrors.tickets[index].numberOfTicketsLeft
                            ? AdminUploadEventStyle.errorInput
                            : ""
                            }`}
                          style={{ textAlign: "right" }} // Keeping for alignment
                        />
                        <span className={AdminUploadEventStyle.ticketLabel}>
                          Tickets
                        </span>
                      </div>
                      {formErrors.tickets &&
                        formErrors.tickets[index] &&
                        formErrors.tickets[index].numberOfTicketsLeft && (
                          <div className={AdminUploadEventStyle.errorMessage}>
                            {formErrors.tickets[index].numberOfTicketsLeft}
                          </div>
                        )}
                    </td>
                    {/* End Sells Time Input */}
                    <td>
                      <input
                        type="time"
                        onChange={(e) =>
                          handleTicketChange(
                            index,
                            "timeofexpir",
                            e.target.value
                          )
                        }
                        className={`${AdminUploadEventStyle.customDateTime} ${AdminUploadEventStyle.customTimeInput} ${formErrors.tickets &&
                          formErrors.tickets[index] &&
                          formErrors.tickets[index].timeofexpir
                          ? AdminUploadEventStyle.errorInput
                          : ""
                          }`}
                      />
                      {formErrors.tickets &&
                        formErrors.tickets[index] &&
                        formErrors.tickets[index].timeofexpir && (
                          <div className={AdminUploadEventStyle.errorMessage}>
                            {formErrors.tickets[index].timeofexpir}
                          </div>
                        )}
                    </td>
                    {/* Description Textarea */}
                    <td className={AdminUploadEventStyle.inputWithTickets}>
                      <textarea
                        value={ticket.description}
                        onChange={(e) =>
                          handleTicketChange(
                            index,
                            "description",
                            e.target.value
                          )
                        }
                        onKeyDown={(e) => handleKeyDown(e, index)}
                        className={`${AdminUploadEventStyle.textareaInput} ${formErrors.tickets &&
                          formErrors.tickets[index] &&
                          formErrors.tickets[index].description
                          ? AdminUploadEventStyle.errorInput
                          : ""
                          }`}
                      />
                      {formErrors.tickets &&
                        formErrors.tickets[index] &&
                        formErrors.tickets[index].description && (
                          <div className={AdminUploadEventStyle.errorMessage}>
                            {formErrors.tickets[index].description}
                          </div>
                        )}
                    </td>
                    {/* Ticket Image */}
                    <td>
                      {ticket.ticketImage ? (
                        <>
                          <img
                            src={ticket.ticketImage}
                            alt="Selected"
                            className={`${AdminUploadEventStyle.thumbnail} ${formErrors.tickets &&
                              formErrors.tickets[index] &&
                              formErrors.tickets[index].ticketImage
                              ? AdminUploadEventStyle.errorInput
                              : ""
                              }`}
                            onClick={() => handleSelectTicketImage(index)}
                          />
                          {formErrors.tickets &&
                            formErrors.tickets[index] &&
                            formErrors.tickets[index].ticketImage && (
                              <div
                                className={AdminUploadEventStyle.errorMessage}
                              >
                                {formErrors.tickets[index].ticketImage}
                              </div>
                            )}
                        </>
                      ) : (
                        <>
                          <button
                            type="button"
                            onClick={() => handleSelectTicketImage(index)}
                            className={`${AdminUploadEventStyle.imageButton} ${formErrors.tickets &&
                              formErrors.tickets[index] &&
                              formErrors.tickets[index].ticketImage
                              ? AdminUploadEventStyle.errorInput
                              : ""
                              }`}
                          >
                            <FontAwesomeIcon icon={faImage} />
                          </button>
                          {formErrors.tickets &&
                            formErrors.tickets[index] &&
                            formErrors.tickets[index].ticketImage && (
                              <div
                                className={AdminUploadEventStyle.errorMessage}
                              >
                                {formErrors.tickets[index].ticketImage}
                              </div>
                            )}
                        </>
                      )}
                    </td>
                    {/* Delete Ticket Button */}
                    <td>
                      {ticket.deletable && (
                        <button
                          onClick={() => deleteTicketType(index)}
                          className={AdminUploadEventStyle.actionButton}
                        >
                          <img src={TrashcanIcon} alt="Delete" />
                        </button>
                      )}
                    </td>
                  </tr>
                  <br />
                </>
              ))}
            </tbody>
          </table>
          <button
            type="button"
            onClick={() => setShowTicketTypes(!showTicketTypes)} // Toggle visibility
            className={AdminUploadEventStyle.addPromoterButton} // Correct class name for styling
          >
            Add Ticket Types
          </button>
          {formErrors.tickets && typeof formErrors.tickets === "string" && (
            <div className={AdminUploadEventStyle.errorMessage}>
              {formErrors.tickets}
            </div>
          )}
          {showTicketTypes && (
            <div className={AdminUploadEventStyle.selectionBox}>
              {ALL_TICKET_TYPES.filter(
                (type) => !tickets.some((ticket) => ticket.ticketType === type)
              ).map((type) => (
                <div
                  key={type}
                  onClick={() => handleAddTicketType(type)}
                  className={AdminUploadEventStyle.selectionItem}
                >
                  {type}
                </div>
              ))}
            </div>
          )}
        </div>
        <div className={AdminUploadEventStyle.checkboxWrapper}>
          <label className={AdminUploadEventStyle.customCheckbox}>
            <input
              type="checkbox"
              name="terms"
              checked={formData.terms}
              onChange={handleChangeBox} // Make sure this function toggles the boolean state
            />
            I accept the Terms and Conditions.
          </label>
        </div>

        <div className={AdminUploadEventStyle.buttonWrapper}>
          <button
            type="button"
            className={AdminUploadEventStyle.gradientButton}
            onClick={handleSubmit}
            disabled={isLoadingSubmitEvent}
          >
            {isLoadingSubmitEvent ? (
              <>
                Uploading <ClipLoader size={20} color="#fff" />
              </>
            ) : (
              "Confirm and Upload Event"
            )}
          </button>
        </div>
      </form>
      <h1 style={{ marginTop: "5%" }}> Table Management</h1>
      <br />
      <h3>Construct and build you table system</h3>
      <div>
        <br />
        <MapsManager />
      </div>
    </div>
  );
};

/*
const TicketSchema = new mongoose.Schema({
  event: {
    name: {
      type: String,
      required: true
    },
    id: {
      type: mongoose.Schema.Types.ObjectId,
      ref: "Events", // Assuming there's a Club model
      required: true
    }
  },
  timeofexpir: {
    type: Number,
    required: true
  },
  ticketType: {
    type: String,
    enum: [
      "guest list",
      "GIRLS ONLY: guest list",
      "guest list 2nd",
      "guest list 3rd",
      "guest list 4rth",
      "discount entrance: pay online",
      "discount entrance: pay at the door",
      "BOYS: 1ST Paid RELEASE OFFER",
      "GIRLS: 1ST Paid RELEASE OFFER",
      "BOYS: 2ND Paid RELEASE OFFER",
      "GIRLS: 2ND Paid RELEASE OFFER",
      "BOYS: 3RD Paid RELEASE OFFER",
      "GIRLS: 3RD Paid RELEASE OFFER",
      "Early Birds Paid Entrance",
      "Paid Entrance 1st offer",
      "Paid Entrance 2nd offer",
      "Paid Entrance 3rd offer"
    ],
    required: true
  },
  description: {
    type: String,
    required: true
  },
  numberOfTicketsLeft: {
    type: mongoose.Schema.Types.Mixed,
    default: 0
  },
  users_having_ticket: {
    type: Array,
    default: []
  },
  users_having_scanned: {
    type: Array,
    default: []
  },
  users_having_scanned_paid: {
    type: Array,
    default: []
  },
  pr_name: {
    type: String,
    default: "None"
  },
  scan_key: {
    type: String,
    default: ""
  },
  QR_tech: {
    type: String,
    enum: ["PATT", "FOURVENUES", "PATT_TECH"],
    default: ""
  },
  ticket_link: {
    type: String,
    default: ""
  },
  ticket_fourvenues_eventid: {
    type: String,
    default: ""
  },
  users_qrcodes: {
    type: mongoose.Schema.Types.Mixed,
    default: {}
  },
  users_eventbrite_tickets: {
    type: mongoose.Schema.Types.Mixed,
    default: {}
  },
  users_having_paid: {
    type: mongoose.Schema.Types.Mixed,
    default: {}
  },
  price: {
    type: Number,
    default: 0
  },
  isPromoters: {
    type: Boolean,
    default: false
  },
  users_referred_bypromoters: {
    type: mongoose.Schema.Types.Mixed,
    default: {}
  },
  promoters_names_ids: {
    type: mongoose.Schema.Types.Mixed,
    default: {}
  },
  promoters_names_maxguestlist: {
    type: mongoose.Schema.Types.Mixed,
    default: {}
  },
  QRs_fourvenues: {
    type: Array,
    default: []
  },
  supportNumber: {
    type: String,
    default: "34603626679"
  }
});

module.exports = mongoose.model("Tickets", TicketSchema, "Tickets");



*/

export default ClubOwnerUploadEvent;
